import _lowerCase from "lodash/fp/lowerCase";
import { TableRow } from "src/requests/table/types";
import produce from "immer";
import { Options } from "src/components/atoms/inputs/FlowioSelect/types";
import { AdminTableName } from "../../../store/tableData/types";
import { useFormattedMsg } from "../../../hooks/useFormatMsg";
import { X2yController } from "../../../store/x2y/types";
import { IntlMessageId } from "../../../assets/localization/types";

type Details = {
  x2yController: X2yController | null;
  pluralName: string;
  labelSourceColumn: string | null; // Column, ze kterýho vezmu jméno záznamu
};
const controllerNameDict: Partial<Record<AdminTableName, X2yController>> = {
  Templates: "templates2Roles",
  Users: "users2Roles",
  Modules: "modules2Roles",
};

const getLabelSourceColumn = (tableName: AdminTableName) => {
  if (tableName === "Users") return "UserName";
  return "Name";
};

// eslint-disable-next-line import/prefer-default-export
export const useDetailsForTableName = (tableName: AdminTableName): Details => {
  const headerIntlId = `common.${_lowerCase(tableName)}` as IntlMessageId; // todo: Změnit z toho assertionu na as const, ale nejdřív bude muset lodash přetyovat ten lowerCase, aby nevracel generickej string

  return {
    x2yController: controllerNameDict[tableName] ?? null,
    labelSourceColumn: getLabelSourceColumn(tableName),
    pluralName: useFormattedMsg(headerIntlId),
  };
};

export const assignValueToUnformattedValueForCells = (
  rows: TableRow[]
): TableRow[] =>
  produce(rows, (draft) => {
    draft.forEach((row, index) => {
      Object.keys(row.cells).forEach((key) => {
        draft[index].cells[key].unformattedValue = row.cells[key].value;
      });
    });
  });

export const getPagingOption = (
  pagingOptions: Options,
  rowsPerPage: number | null
): string => {
  const pagingOption = pagingOptions.find(
    ({ value }) => Number(value) === rowsPerPage
  );

  if (!pagingOption) return "0";

  return pagingOption.value;
};
